import appLocaleData from "react-intl/locale-data/zh";
import zhHKMessages from "../locales/zh-HK";

const ChLang = {
  messages: {
    ...zhHKMessages,
  },
  locale: "zh-HK",
  data: appLocaleData,
};
export default ChLang;
